
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressChequingEN]",
      function () {
        return require("private-next-pages/[...wordpressChequingEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressChequingEN]"])
      });
    }
  